import mainService from './mainService';

export function savedScreensCreate(data) {
    return mainService
        .post(`savedScreens/create`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function savedScreensRecords(data) {
    let parameters = '';

    for (const key in data) {
        const value = data[key];
        switch (key) {
            case 'port':
                parameters = `${parameters}&port=${value}`;
                break;
            case 'order':
                parameters = `${parameters}&order=${value.type}.${value.order}`;
                break;
            case 'page':
                parameters = `${parameters}&page=${value}`;

                break;
            case 'filter':
                if (value.length >= 1) {
                    parameters = `${parameters}&filter=${value}`;
                }
                break;
            case 'search':
                if (value.length >= 1) {
                    parameters = `${parameters}&search=${value.join(',')}`;
                }
                break;
        }
    }

    return mainService
        .get(`savedScreens/records?rand=${new Date().getTime()}${parameters}`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function savedScreensRecord(uuid: string) {
    return mainService
        .get(`savedScreens/${uuid}`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function savedScreensDelete(id) {
    return mainService
        .delete(`savedScreens/delete/${id}`)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
